import { createSlice } from "@reduxjs/toolkit";
import { Imagenes } from "interfaces/expedientes/expedientesInterface";
import { PortadaCarpeta } from "../../models/portadasActuaciones/PortadaCarpeta";
import { DataVideoAud } from "interfaces/videoAudiencia/videoAudienciaInterface";

export type ExpedienteState = {
  cveTipoActuacionSelected: 0;
  currentPortada: any;
  portadaCarpeta: PortadaCarpeta | null;
  portadasActuaciones: any[];
  listFiles: string[];
  portadaPenalLaboral: any;
  isErrorPortada: boolean;
  nodoSelected: string;
  videoAudiencia: DataVideoAud | null;
  showVideo: boolean;
  actuacion: any;
  bodyRequest: any;
  tokenData: string | null;
  infoVideo: any;
  isSearch: boolean;
  penalAdolescente: string;
  isCentral: boolean;
  isRegresar: boolean;
  posExpediente: any;
  lstArbol: [];
  datosContext: any;
  rutaPdf: any;
  detallesCarpeta: any;
  detalleCarpetaJudicialExhorto: any[];
  cveSistemaMateria: number;
  isArchivado: any;
  filtosChecked: any;
  loadingArchivar: boolean;
  resertChecks: boolean;
  lstExpedientes: any[];
  datosCaratula: any;
};

export const expedienteSlice = createSlice({
  name: "expediente",
  initialState: {
    cveTipoActuacionSelected: 0,
    currentPortada: null,
    portadaCarpeta: null,
    portadasActuaciones: [],
    listFiles: [],
    portadaPenalLaboral: null,
    isErrorPortada: false,
    nodoSelected: "",
    videoAudiencia: null,
    showVideo: false,
    actuacion: null,
    bodyRequest: null,
    tokenData: null,
    infoVideo: null,
    isSearch: false,
    penalAdolescente: "",
    isCentral: false,
    isRegresar: true,
    posExpediente: null,
    lstArbol: [],
    datosContext: null,
    rutaPdf: null,
    detallesCarpeta: [],
    detalleCarpetaJudicialExhorto: [],
    cveSistemaMateria: 0,
    isArchivado: [],
    filtosChecked: [1],
    loadingArchivar: false,
    resertChecks: false,
    lstExpedientes: [],
    datosCaratula: [],
  } as ExpedienteState,
  reducers: {
    onLoadTokenData(state, action) {
      state.tokenData = action.payload;
    },
    setPortadaCarpeta(state, action) {
      state.portadaCarpeta = action.payload;
    },
    pushPortadaActuacion(state, action) {
      state.portadasActuaciones.push(action.payload);
    },
    addListFilesPenalDemandado: (state, { payload }) => {
      state.listFiles = payload;
    },
    onAddNodoSelected: (state, { payload }) => {
      state.nodoSelected = payload;
    },
    onAddLstArbol: (state, { payload }) => {
      state.lstArbol = payload;
    },
    onAddRutaPdf: (state, { payload }) => {
      state.rutaPdf = payload;
    },
    setProperties(state, action) {
      const keys = Object.keys(action.payload);
      keys.forEach((key) => {
        // @ts-ignore
        state[key] = action.payload[key];
      });
    },
    onAddPortadaPenalLaboral: (state, { payload }) => {
      state.portadaPenalLaboral = payload;
    },
    onIsErrorGetPortada: (state, { payload }) => {
      state.isErrorPortada = payload;
    },
    onLoadVideoAudiencia: (state, { payload }) => {
      state.videoAudiencia = payload;
    },
    onSelectVideo: (state, { payload }) => {
      state.showVideo = payload;
    },
    onSelectActuacion: (state, { payload }) => {
      state.actuacion = payload;
    },
    onSelectVideoAud: (state, { payload }) => {
      state.bodyRequest = payload;
    },
    onLoadVideoInfo: (state, { payload }) => {
      state.infoVideo = payload;
    },
    onSearchExpedientes: (state, { payload }) => {
      state.isSearch = payload;
    },
    onLoadPenalAdolscente: (state, { payload }) => {
      state.penalAdolescente = payload;
    },
    onChangeIsCentral: (state, { payload }) => {
      state.isCentral = payload;
    },
    onChangeIsRegresar: (state, { payload }) => {
      state.isRegresar = payload;
    },
    onSetExpediente: (state, { payload }) => {
      state.posExpediente = payload;
    },
    onSetCurrentPortada: (state, { payload }) => {
      state.currentPortada = payload;
    },
    onSetDatosContext: (state, { payload }) => {
      state.datosContext = payload;
    },

    onSetDetallesPortada: (state, { payload }) => {
      state.detallesCarpeta = payload;
    },
    onSetDetallesPortadaExhortos: (state, { payload }) => {
      state.detalleCarpetaJudicialExhorto = payload;
    },
    onSetCveSistemaMateria: (state, { payload }) => {
      state.cveSistemaMateria = payload;
    },
    onSetArchivado: (state, { payload }) => {
      state.isArchivado = payload;
    },
    onSetFiltrosChecked: (state, { payload }) => {
      state.filtosChecked = payload;
    },
    onLoadingArchivar: (state, { payload }) => {
      state.loadingArchivar = payload;
    },
    onResetChecks: (state, { payload }) => {
      state.resertChecks = payload;
    },
    onSetLstExpedientes: (state, { payload }) => {
      state.lstExpedientes = payload;
    },
    onSetDatosCaratula: (state, { payload }) => {
      state.datosCaratula = payload;
    },
    onResetStatePortadas: (state) => {
      state.cveTipoActuacionSelected = 0;
      state.currentPortada = null;
      state.portadaCarpeta = null;
      state.portadasActuaciones = [];
      state.listFiles = [];
      state.portadaPenalLaboral = null;
      state.isErrorPortada = false;
      state.nodoSelected = "";
      state.isCentral = false;
      state.lstArbol = [];
      state.datosContext = null;
      state.rutaPdf = null;
      state.detallesCarpeta = [];
      state.detalleCarpetaJudicialExhorto = [];
    },
    onResetVideoAudiencia: (state) => {
      state.videoAudiencia = null;
      state.showVideo = false;
      state.actuacion = null;
      state.bodyRequest = null;
      state.tokenData = null;
    },

    onResetDeralles: (state) => {
      state.detallesCarpeta = [];
    },
  },
});

export const {
  onLoadTokenData,
  addListFilesPenalDemandado,
  onAddNodoSelected,
  onAddPortadaPenalLaboral,
  onIsErrorGetPortada,
  onLoadVideoAudiencia,
  onResetStatePortadas,
  onSelectVideo,
  setPortadaCarpeta,
  onSelectActuacion,
  onSelectVideoAud,
  onLoadVideoInfo,
  onResetVideoAudiencia,
  onSearchExpedientes,
  onLoadPenalAdolscente,
  onChangeIsCentral,
  onChangeIsRegresar,
  onSetExpediente,
  onAddLstArbol,
  onSetDatosContext,
  onSetCurrentPortada,
  onAddRutaPdf,
  onSetDetallesPortada,
  onResetDeralles,
  onSetDetallesPortadaExhortos,
  onSetCveSistemaMateria,
  onSetArchivado,
  onSetFiltrosChecked,
  onLoadingArchivar,
  onResetChecks,
  onSetLstExpedientes,
  onSetDatosCaratula,
} = expedienteSlice.actions;
